export default {
  resetCampaignList(state, payload) {
    state.campaignsList = { nextPageToken: "", data: [] };
  },
  setCampaignsList(state, payload) {
    state.campaignsList = {
      data: state.campaignsList.data.concat(payload.campaigns),
      nextPageToken: payload.nextPageToken
    };
  },
  setCampaign(state, payload) {
    state.campaign = payload;
  },
  setCampaignReport(state, payload) {
    state.campaignReport = payload;
  },
  setCampaignPreview(state, payload) {
    state.campaignPreview = payload;
  }
};
